import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'

export const demographicGenderService = {
	/**
	 * Get all demographic genders
	 */
	getDemographicGenders(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/types/demographicGenders', config)
	},
}

export default demographicGenderService
